import React from "react";
import { Stack, Typography, styled, Avatar, Box } from "@mui/material";

const Card = styled(Stack)(({ theme }: any) => ({
  justifyContent: "space-evenly",
  width: "100%",
  height: "300px",
  border: `1px solid ${theme.palette.common.borderGrey}`,
  alignItems: "center"
}));

export interface SpeakerCardInterface {
  image: string;
  name: string;
  position: string;
  events: number;
  followers: number;
  bookmarked?: boolean;
  setBookmarked: () => void;
}

const SpeakerCard = ({
  image,
  name,
  position,
  events,
  followers,
  bookmarked = false,
  setBookmarked
}: SpeakerCardInterface) => {
  return (
    <Card px={1.2} py={2.5} spacing={0.5}>
      <Stack alignSelf="center">
        <Avatar
          alt="Remy Sharp"
          src={image}
          sx={{ width: "128px", height: "128px" }}
        />
      </Stack>
      <Typography color="primary" fontSize={16} fontWeight={700}>
        {name}
      </Typography>
      <Typography variant="h5" className="font-darkGrey">
        {position}
      </Typography>
      <Stack display="flex" flexDirection="row" alignItems="center">
        <Typography fontWeight={500} variant="h5">
          {events} events{" "}
        </Typography>
        <Box
          width=" 7px"
          height="7px"
          style={{ backgroundColor: "black", borderRadius: "10px" }}
          ml={1}
          mr={1}
        />
        <Typography fontWeight={500} variant="h5">
          {followers} followers
        </Typography>
      </Stack>
      <Stack>
        {bookmarked
          ? <i className="fas fa-bookmark" onClick={setBookmarked} />
          : <i className="far fa-bookmark" onClick={setBookmarked} />}
      </Stack>
    </Card>
  );
};
export default SpeakerCard;
